module.exports = __webpack_public_path__ + "img/normal_multiplier_4.86f43ce3.png";